import AmethystGem from './amethyst.webp';
import MemberGem from './member.webp';
import AquamarineGem from './aquamarine.webp';
import DiamondGem from './diamond.webp';
import EmeraldGem from './emerald.webp';
import OpalGem from './opal.webp';
import RubyGem from './ruby.webp';
import SapphireGem from './sapphire.webp';
import TopazGem from './topaz.webp';
import VipGem from './vip.webp';

import AmethystGemLocked from './amethyst-locked.webp';
import AquamarineGemLocked from './aquamarine-locked.webp';
import DiamondGemLocked from './diamond-locked.webp';
import EmeraldGemLocked from './emerald-locked.webp';
import OpalGemLocked from './opal-locked.webp';
import RubyGemLocked from './ruby-locked.webp';
import SapphireGemLocked from './sapphire-locked.webp';
import TopazGemLocked from './topaz-locked.webp';
import VipGemLocked from './vip-locked.webp';

import AmethystGlow from './amethyst-glow.webp';
import AquamarineGlow from './aquamarine-glow.webp';
import DiamondGlow from './diamond-glow.webp';
import EmeraldGlow from './emerald-glow.webp';
import OpalGlow from './opal-glow.webp';
import RubyGlow from './ruby-glow.webp';
import SapphireGlow from './sapphire-glow.webp';
import TopazGlow from './topaz-glow.webp';
import VipGlow from './vip-glow.webp';

import StatusTutorialWeb from './statusTutorialWeb.webp';
import StatusTutorialMobile from './statusTutorialMobile.webp';
import StatusBanner from './statusBanner.webp';
import Hourglass from './hourglass.webp';
import Timeout from './timeout.webp';
import Perks from './perks.webp';
import Glow from './glow.webp';
import StatusSlideOne from './status-slide-1.webp';
import StatusSlideTwo from './status-slide-2.webp';
import StatusSlideThree from './status-slide-3.webp';

import GemStonesPerk from './bonanzaCoinStack.webp';
import DailyWheelPerk from './dailyWheel.webp';
import ShopWeeklyPromotionPerk from './discount.webp';
import AccessToBetterRafPerk from './raf.webp';
import StatusExclusiveGamesPerk from './exclusive.webp';
import MultiplierOnLevelUpPerk from './levelUp.webp';
import PriorityCustomerSupportPerk from './support.webp';
import CashbackPerk from './cashback.webp';

export default {
  MemberGem,
  AmethystGem,
  AquamarineGem,
  DiamondGem,
  EmeraldGem,
  OpalGem,
  RubyGem,
  SapphireGem,
  TopazGem,
  VipGem,

  MemberGlow: AmethystGlow,
  AmethystGlow,
  AquamarineGlow,
  DiamondGlow,
  EmeraldGlow,
  OpalGlow,
  RubyGlow,
  SapphireGlow,
  TopazGlow,
  VipGlow,

  StatusTutorialWeb,
  StatusTutorialMobile,
  StatusBanner,
  Hourglass,
  Timeout,
  Perks,
  Glow,
  StatusSlideOne,
  StatusSlideTwo,
  StatusSlideThree,

  // Perks
  GemStonesPerk,
  DailyWheelPerk,
  ShopWeeklyPromotionPerk,
  AccessToBetterRafPerk,
  StatusExclusiveGamesPerk,
  MultiplierOnLevelUpPerk,
  PriorityCustomerSupportPerk,
  CashbackPerk,
  VipHostPerk: undefined,

  // Locked gems
  MemberGemLocked: undefined,
  AmethystGemLocked,
  AquamarineGemLocked,
  DiamondGemLocked,
  EmeraldGemLocked,
  OpalGemLocked,
  RubyGemLocked,
  SapphireGemLocked,
  TopazGemLocked,
  VipGemLocked,
};
